import React, { useState } from 'react'

import classNames from 'classnames'
import { DataItem, connect } from 'scrivito'

import { DataImage } from '../../DataImage'
import { StringText } from '@/Atomic/Atoms/StringText'
import { FileIcon } from '@/Atomic/Molecules/FileIcon'
import { getFileExtension } from '@/Atomic/Molecules/FileIcon/utils'
import { MenuItemProps } from '@/Atomic/Molecules/MenuItem'
import { DropdownMenu } from '@/Atomic/Organisms/DropdownMenu'
import { DocumentBodyBinary } from '@/Components/Document/types'
import { FullDataBinary } from '@/utils/dataBinaryToUrl'

interface DocumentFileBoxProps {
  documentBody: DocumentBodyBinary
  document: DataItem
  onOpenDrawer: (e: React.MouseEvent) => void
  title: string | null
  menuItems: MenuItemProps[]
}

export const DocumentFileBox: React.FC<DocumentFileBoxProps> = connect(
  ({ documentBody, document, onOpenDrawer, title, menuItems }) => {
    const thumnbail = document.get('bodyThumbnail') as FullDataBinary

    const fileName = title || documentBody?.filename || 'File'
    const format = (document.get('format') as string | undefined) || ''
    const fileExtension = format || getFileExtension(documentBody?.filename)
    const [isMenuOpen, setIsMenuOpen] = useState(false)

    return (
      <div
        className={classNames('document-file-box', {
          'menu-open': isMenuOpen,
        })}
      >
        <div className="hover-area">
          <div className={classNames('box-header', { filled: thumnbail })}>
            <DropdownMenu
              buttonClassName=""
              boundarySelector=".documents-tab ul"
              menuItems={menuItems}
              onOpenChange={setIsMenuOpen}
            />
          </div>
          <div className="content" onClick={onOpenDrawer}>
            <div className="preview">
              {thumnbail ? (
                <DataImage dataBinary={thumnbail} defaultImage="file-big" />
              ) : (
                <div className="fallback-icon">
                  <FileIcon size="lg" extension={fileExtension} />
                </div>
              )}
            </div>
            <div className="file-icon-wrapper">
              <FileIcon extension={fileExtension} showExtensionLabel />
            </div>
          </div>
        </div>
        <StringText wrapperClassName="file-title" value={fileName} />
      </div>
    )
  },
)
